export default __webpack_public_path__ + "static/media/set_1_360.25e1d1ff.svg";